/** Textes « auth » — le français fait foi. */
export const auth = {
};
